import React, { useRef } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { selectHasAppAccess } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { Loader } from '@/ui'

interface Props {
  component: React.ElementType
}

const PrivateRoute = ({ component: RouteComponent, ...rest }: Props) => {
  const location = useLocation()
  const userHasAppAccess = useReselector(selectHasAppAccess)
  const auth = useReselector((state) => state.auth.security)
  const wasAuthenticated = useRef(false)

  if (auth.isAuthenticated) {
    wasAuthenticated.current = true
    if (localStorage.getItem('targetLink')) {
      localStorage.removeItem('targetLink')
    }
    return userHasAppAccess === null ? (
      <Loader active />
    ) : (
      <RouteComponent {...rest} />
    )
  }

  // Only capture a return path when the route loaded unauthenticated (a deep
  // link to login). On logout the route was authenticated first, so skip it —
  // otherwise the user-facing page leaks into the next login's redirect.
  if (!wasAuthenticated.current) {
    localStorage.setItem(
      'targetLink',
      location.pathname + location.search + location.hash
    )
  }
  return <Navigate to="/login" />
}

export default PrivateRoute
